import { ColDef, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadMessageLogsExport, LoadUsers } from "../../../actions";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount } from "../../../helpers/header.helper";
import setToast from "../../../helpers/toaster.helper";
import { ClearSelectionIcon, DeleteLogsIcon, DownloadLogsIcon, FailDotIcon, InProgressDotIcon, SuccessDotIcon, TollfreeIcon, UnDownloadLogsIcon } from "../../../icon";
import { MessageLogExportModel } from "../../../models/msg.export.model";
import * as selector from "../../../selectors/selectors";
import { UtilityService } from "../../../services/UtilityService";
import { MessageLogSevice } from "../../../services/messageLogService";
import Confirm_Dialog from "../../shared/confirm-dialog.component";
import { ActionLabels, emptyLabels, pageTitles } from "../../shared/constants";
import GridComponent from '../../shared/grid';
import { ExportComponent, messageLogDownLoad } from "../../shared/grid/export-component";
import { TypeRenderer } from "../../shared/grid/typeRendrer";
import PageHeaderComponent from "../../shared/page-header.component";
import { ToasterType } from "../../shared/toaster/toaster.model";

interface BackgroundFileData {
    FileName: string;
    FileKey: string;
}

interface IStateProps {

}

interface IDispatchProps {

}
interface IProps extends IStateProps, IDispatchProps { }

const ExportMsgLogsComponent = (props: IProps) => {
    const [gridApi, setGridApi] = useState<any>(null);
    const ExportMessageLogs = useSelector(selector.ExportMessageLogs)
    const Users = useSelector(selector.users)
    const [columnApi, setColumnApi] = useState<any>(null);
    const [messageLogs, setMessageLogs] = useState<MessageLogExportModel[]>(ExportMessageLogs);
    const [checkedExports, setCheckExports] = useState<MessageLogExportModel[]>([]);
    const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isBulkDelete, setIsBulkDelete] = useState<boolean>(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
    const [id, setId] = useState<string>(undefined);
    const dispatch = useDispatch()

    useEffect(() => {
        setMessageLogs(ExportMessageLogs.filter((log) => log.status !== "InProgress"))
    }, [ExportMessageLogs])

    useEffect(() => {
        if (Users.length === 0) {
            LoadUsers(dispatch)
        }
        LoadMessageLogsExport(dispatch);
    }, [])

    const gridRefresh = () => {
        LoadMessageLogsExport(dispatch);
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    useEffect(() => {
        setHeaderTitle(pageTitles.EXPORT_REPORTS);
        setHeaderCount(ExportMessageLogs?.length || 0)
        setRefreshHandler(gridRefresh);
        return setHeaderTitle
    }, [gridApi, columnApi])

    useEffect(() => {
        setHeaderCount(ExportMessageLogs?.length || 0)
        setSelectedCount(0)
    }, [ExportMessageLogs])

    const onGridReady = (params) => {
        setGridApi(params.api)
    }

    const onSelectionChanged = () => {
        let CheckedExports: MessageLogExportModel[] = gridApi.getSelectedRows()
        if (gridApi && CheckedExports.length > 0) {
            setShowMultiActionButtons(true);
            setCheckExports(CheckedExports);
            setSelectedCount(CheckedExports.length)
        }
        else {
            setShowMultiActionButtons(false);
            setCheckExports([]);
            setSelectedCount(CheckedExports.length)
        }
    }


    const ReportsColoumnDefs: ColDef[] = [
        {
            field: "data",
            headerName: "File Name",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data.data !== null) {
                    const fileData: BackgroundFileData = JSON.parse(params.data.data);
                    return UtilityService.trimMessage(fileData.FileName, 17)
                } else {
                    return "No file name"
                }
            },
            cellClass: "c-pointer",
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: "status",
            headerName: "Status",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.status;
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.status !== null) {
                    const label = params.data.status === "InProgress" ? "In Progress" : params.data.status;
                    const icon = params.data.status === "Completed" ? SuccessDotIcon : params.data.status === "Fail" ? FailDotIcon : params.data.status === "InProgress" ? InProgressDotIcon : TollfreeIcon;
                    const Type = {
                        component: TypeRenderer,
                        params: {
                            Icon: icon, Label: label, Id: params.data.id
                        }
                    }
                    return Type
                }
            },
            minWidth: 100,
            width: 100,
            maxWidth: 140,
        },
        {
            field: "createdById",
            headerName: "Created by",
            valueGetter: (params: ValueGetterParams) => {
                if (Users) {
                    const user = Users.find((u) => u.ID === params.data.createdById)
                    if (!!user) {
                        let name = user?.PhoneNumber
                        if (user.FirstName) {
                            name = Users.find((u) => u.ID === params.data.createdById)?.FirstName;
                        }
                        if (user.LastName) {
                            name = name + " " + Users.find((u) => u.ID === params.data.createdById)?.LastName
                        }
                        return UtilityService.trimMessage(name, 17);
                    } else {
                        return ""
                    }
                } else {
                    return "No Data"
                }
            },
            cellClass: "c-pointer",
        },
        {
            field: "createdDateTime",
            headerName: "Created on",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertToDateTimeFormat(
                    params.data.createdDateTime
                );
            },
            cellClass: "c-pointer",
        },

        {
            headerName: "Download",
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.status === "Completed") {
                    if (params.data.data !== null) {
                        const fileData: BackgroundFileData = JSON.parse(params.data.data);
                        const Type = {
                            component: ExportComponent,
                            params: {
                                Icon: DownloadLogsIcon, Id: params.data.id, IsDelete: false, FileKey: fileData.FileKey
                            }
                        }
                        return Type
                    }
                } else {
                    const Type = {
                        component: ExportComponent,
                        params: {
                            Icon: UnDownloadLogsIcon, Id: params.data.id, IsDelete: false
                        }
                    }
                    return Type
                }
            },
            cellClass: "c-pointer justify-center",
            minWidth: 100,
            width: 100,
            maxWidth: 140,
        },
        {
            headerName: "Delete",
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.id !== null) {
                    const Type = {
                        component: ExportComponent,
                        params: {
                            Icon: DeleteLogsIcon, Id: params.data.id, IsDelete: true, onDeleteFile: () => {
                                openDeleteConfirmDialog();
                                setId(params.data.id);
                            }, id: params.data.id
                        }
                    }
                    return Type
                }
            },
            cellClass: "c-pointer justify-center",
            minWidth: 100,
            width: 100,
            maxWidth: 140,
        },
    ]

    const searchReport = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const openDeleteConfirmDialog = (isBulk?: boolean) => {
        setIsBulkDelete(isBulk)
        setIsLoading(false);
        setShowConfirmDialog(true);
    }

    const closeDeleteConfirmDialog = () => {
        setIsLoading(false);
        setShowConfirmDialog(false);
        setId(undefined);
    }

    const deleteMsgLogExport = async (fileKey: string) => {
        try {
            setIsLoading(true);
            await MessageLogSevice.deleteMessagwlogReportfromDb(fileKey)
            setToast(`Message logs deleted.`, ToasterType.SUCCESS)
            clearSelection();
            LoadMessageLogsExport(dispatch);
            closeDeleteConfirmDialog();
        } catch (e) {
            setToast(`Message logs delete fail.`, ToasterType.DANGER)
            closeDeleteConfirmDialog();
        }
        setIsLoading(false);
    }

    const deleteFile = () => {
        try {
            deleteMsgLogExport(id);
            setId(undefined);
        } catch (e) {
            setToast(`Message logs delete fail.`, ToasterType.DANGER)
        }
    }

    const getGridTitle = () => {
        if (showMultiActionButtons) {
            return checkedExports?.length + " of " + ExportMessageLogs?.length + " " + "Files" + " selected"
        }
        else {
            if (ExportMessageLogs?.length === 1) {
                return "1 File"
            }
            else {
                return ExportMessageLogs?.length + " " + "Files"
            }
        }
    }

    const handleConfirmDialogClose = (isConfirm: boolean) => {
        if (isConfirm) {
            if (isBulkDelete) {
                deleterHandler()
            } else {
                deleteFile();
            }
        } else {
            closeDeleteConfirmDialog();
        }
    }

    const clearSelection = () => {
        if (!!gridApi && !!checkedExports?.length) {
            gridApi.deselectAll();
        }
        setCheckExports([])
    }

    function multipleDownload() {
        setToast(`Message logs download started.`, ToasterType.INFO)
        if (checkedExports.length > 0) {
            const downloadPromises = checkedExports.map((e) => {
                if (e.status === "Completed") {
                    const fileData = JSON.parse(e.data);
                    return messageLogDownLoad(fileData.FileKey, true);
                }
            }).filter(promise => promise != null || undefined);
            Promise.all(downloadPromises)
                .then(() => {
                    setToast(`All message logs downloaded successfully. You can check them!`, ToasterType.SUCCESS);
                })
                .catch(() => {
                    setToast(`Some message logs failed to download.`, ToasterType.DANGER);
                });
        }
        clearSelection();
    }

    async function deleterHandler() {
        try {
            setIsLoading(true)
            setToast(`Message logs delete process started.`, ToasterType.INFO)
            const ids = []
            checkedExports.forEach((e) => {
                const fileData: BackgroundFileData = JSON.parse(e.data);
                ids.push(e.id);
            })
            await MessageLogSevice.deleteBulkMessagwlogReportfromDb(ids)
            setIsLoading(false)
            clearSelection();
            closeDeleteConfirmDialog();
            LoadMessageLogsExport(dispatch);
            setToast(`Message logs files deleted.`, ToasterType.SUCCESS)
        } catch (e) {
            setToast(`Message logs files delete process failed.`, ToasterType.DANGER)
        }
    }

    const checkBtnValidity = (): boolean => {
        if (checkedExports.length > 0) {
            return checkedExports?.filter((logs => logs.status !== "Completed")).length === checkedExports?.length
        } else {
            return false
        }
    }

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            {showConfirmDialog && <Confirm_Dialog
                onClose={handleConfirmDialogClose}
                Show={showConfirmDialog}
                Text={"This will permanently delete the file. Do you wish to proceed?"}
                ButtonName={"Confirm"}
                Loading={isLoading}
                IsMobileDevice={false}
                Title="Delete this file?"
                CheckBoxText={"Also delete the contacts in this group"}
            />}

            <div>
                <PageHeaderComponent
                    onSearch={searchReport}
                    GridTitle={""}
                    Count={ExportMessageLogs.length}
                    PlaceHolder={"Find a File..."}
                    ShowFilterIcon={false}
                    ShowMultiActionButtons={showMultiActionButtons}
                    MultiActionButtons={[
                        {
                            Name: ActionLabels.DOWNLOAD,
                            Variant: "primary",
                            Hide: checkBtnValidity(),
                            ClassName: "mr-1",
                            OnClick: () => multipleDownload()
                        },
                        {
                            Name: ActionLabels.DELETE,
                            Variant: !!checkedExports?.length ? "primary" : "disabled",
                            ClassName: "mr-1",
                            OnClick: () => openDeleteConfirmDialog(true)
                        },
                        {
                            Name: ActionLabels.CLEAR_SELECTION,
                            Variant: "text",
                            ClassName: "p-0 mr-1 w-space",
                            Icon: ClearSelectionIcon,
                            OnClick: () => clearSelection(),
                        }
                    ]}
                />
                {<div className="report-text color-conv-section-inactive my-1 px-3">
                    <div>This table shows all exports initiated in the past 14 days. A download link will appear once your export is ready. Use the refresh option to view the latest status.</div>
                    <div><span>Note: </span><span className="h6-semibold">Exports older than 14 days are automatically deleted.</span></div>
                </div>}
            </div>
            <GridComponent
                ColumnDefs={ReportsColoumnDefs}
                OnSelectionChanged={onSelectionChanged}
                RowData={messageLogs}
                OnGridReady={onGridReady}
                IsPaginationEnabled={true}
                EmptyLabel={emptyLabels.REPORTS}
                LockVisible={false}
                IsFilterPresent={false}
                gridApi={gridApi}
            />
        </div>
    )
}

export default ExportMsgLogsComponent
